export const GET_TOPIC = "GET_TOPIC"
export const GET_TOPIC_SUCCESS = "GET_TOPIC_SUCCESS"
export const ADD_TOPIC = " ADD_TOPIC"
export const ADD_TOPIC_SUCCESS = " ADD_TOPIC_SUCCESS"
export const RESET_STORE_TOPIC = "RESET_STORE_TOPIC"
export const DELETE_TOPIC = "DELETE_TOPIC"
export const DELETE_TOPIC_SUCCESS = "DELETE_TOPIC_SUCCESS"

